import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    Text: _objectSpread(_objectSpread({
      paddingRight: 5
    }, theme.typography.body), {}, {
      color: theme.colors.neutral900
    }),
    info: {
      display: 'block'
    },
    icon: {
      display: 'block',
      width: 14,
      height: 14,
      cursor: 'pointer',
      '& svg': {
        width: 14,
        height: 14,
        marginTop: -1
      },
      '& path': {
        fill: theme.colors.neutral600
      }
    }
  };
});